import {useState,useEffect, ChangeEvent, useContext} from 'react';
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Container, Spinner } from 'reactstrap';
import TablaCategoriaProductos from './TablaCategoriaProductos';
import IngresoCategoriaProducto from './IngresoCategoriaProducto';
import { GuardarCategoria, ProductoEsperado, getCategoriaVacia } from '../../../interfaces/Sistema';
import AlertService from '../../../services/AlertService';
import CertificadoService from '../../../services/CertificadoService';
import UsuarioService from '../../../services/UsuarioService';
import CatalogService from '../../../services/CatalogService';
import { CasUserContext, useCasUserContext } from '../../../services/casUserContext';



const alertaService = new AlertService;
const certificadoService = new CertificadoService;
const usuarioservice = new UsuarioService;
const catalogoService = new CatalogService();



interface opcion{
  value:string,
  label: string,
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Container>{children}</Container>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}



export default function CategoriaProductos(){
  const[ready,SetReady] = useState(false);
  //const casUserContext = useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  const token = casUserContext.token;
  const [value, setValue] = React.useState(0);
  const [productosActivos,setProductosActivos] = useState<Array<ProductoEsperado>>([]) ;
  const productosOpcion:Array<opcion>= Array<opcion>()
  const [categoriaInicial, setCategoriaInicial]= useState<GuardarCategoria>(()=>getCategoriaVacia())

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const fetchData = async () =>{
    try{
         alertaService.showLoading("Cargando Datos..."); 
         await catalogoService.GetProductosEsperadosTodos() 
         .then((data)=>{
            if(data.status.isSuccessfully){
                setProductosActivos(data.listData.reverse())
                SetReady(true)
            }
         }) 
         .catch((error) => console.error(error));               
         alertaService.hideLoading();                
    }catch(error){
      console.error('Error:',error);
    }
  };

useEffect(() => {
    fetchData();
    },[]);

 useEffect(() => {
    fetchData();
 },[token]);


  productosActivos.map((row)=>{
    let opc : opcion={
      value: row.idProducto.toString(),
      label: row.nombreProducto
    }
    if(opc.value!='0'){
      productosOpcion.push(opc)
    }
    

  })

  if(!ready){
    return <Spinner
  color="primary"
  style={{
    height: '3rem',
    width: '3rem'
  }}
  >
    Loading...
  </Spinner>; // Mostrar un indicador de carga mientras se obtienen los datos
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Categorías de productos" {...a11yProps(0)} />
          <Tab label="Consulta de categorías de productos" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0} >
        <IngresoCategoriaProducto productosActivos={productosOpcion} categoria={categoriaInicial} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TablaCategoriaProductos rowsPerPage={[5 ,10, 25, 100]} />
      </CustomTabPanel>
     
    </Box>
  );

}